import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { th, enUS } from "date-fns/locale";
import { cn } from "src/lib/utils";
import { useTranslation } from "react-i18next";
import { format, addYears } from "date-fns";
import "./datepicker.css";

const DateRangeSelectorNew = ({ customActive, setCustomRange, setStartDate, setEndDate, plantId }) => {
  const { t, i18n } = useTranslation("main");
  const [dateRange, setDateRange] = useState([null, null]);
  const [start, end] = dateRange;

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setDateRange(dates);

    if (start && end) {
      const fromDate = new Date(start);
      const toDate = new Date(end);
      const diffInDays = (toDate - fromDate) / (1000 * 60 * 60 * 24);

      if ((plantId === 4933 || plantId === 4934) && diffInDays > 3) {
        alert(t("main:dateTime.alertMessage"));
        return;
      }

      console.log(start,end,"start,end")

      // Format dates in 'YYYY-MM-DD' format when setting
      const formattedStartDate = format(start, 'yyyy-MM-dd');
      const formattedEndDate = format(end, 'yyyy-MM-dd');
      
      setStartDate(formattedStartDate);
      setEndDate(formattedEndDate);
      setCustomRange("custom");
    }
  };

  const formatDateRange = () => {
    if (start && end) {
      if (i18n.language === "th") {
        const startStr = format(start, "d MMM", { locale: th }) + " " + (start.getFullYear() + 543);
        const endStr = format(end, "d MMM", { locale: th }) + " " + (end.getFullYear() + 543);
        return `${startStr} - ${endStr}`;
      }
      const startStr = format(start, "d MMM yyyy", { locale: enUS });
      const endStr = format(end, "d MMM yyyy", { locale: enUS });
      return `${startStr} - ${endStr}`;
    }
    return i18n.language === "th" ? "วว ดด ปปปป - วว ดด ปปปป" : "DD MMM YYYY - DD MMM YYYY";
  };

  const renderCustomHeader = ({
    date,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  }) => (
    <div className="flex items-center justify-between px-3 py-2 bg-gradient-to-b from-[#043025] to-[#032018] shadow-xl transition-all duration-300">
      <button
        onClick={decreaseMonth}
        disabled={prevMonthButtonDisabled}
        type="button"
        className="p-1 text-white hover:text-gray-900 disabled:opacity-50"
      >
        ←
      </button>
      <div className="text-lg font-semibold text-white bg-gradient-to-b from-[#043025] to-[#032018] shadow-xl transition-all duration-300 ">
        {i18n.language === "th" 
          ? format(date, "MMMM", { locale: th }) + " " + (date.getFullYear() + 543)
          : format(date, "MMMM yyyy", { locale: enUS })}
      </div>
      <button
        onClick={increaseMonth}
        disabled={nextMonthButtonDisabled}
        type="button"
        className="p-1 text-white hover:text-gray-900 disabled:opacity-50"
      >
        →
      </button>
    </div>
  );

  return (
    <div className="relative w-full h-full mx-auto" id="dateRangeSelector ">
      <DatePicker
        selected={start}
        onChange={handleDateChange}
        startDate={start}
        endDate={end}
        selectsRange
        locale={i18n.language === "th" ? th : enUS}
        dateFormat={i18n.language === "th" ? "d MMM yyyy" : "d MMM yyyy"}
        renderCustomHeader={renderCustomHeader}
        calendarClassName="custom-calendar shadow-lg"
        maxDate={new Date()}
        showPopperArrow={false}
        placeholderText={i18n.language === "th" ? "วว ดด ปปปป - วว ดด ปปปป" : "DD MMM YYYY - DD MMM YYYY"}
      />
    </div>
  );
};

export default DateRangeSelectorNew; 